(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('formLabelAction', formLabelAction);

    function formLabelAction() {
        return {
            restrict: 'A',
            scope: {
                event: '=?'
            },
            link: function(scope, elem) {
                elem.bind('click', function(e) {
                    e.preventDefault();
                    if (scope.event && scope.event.length > 0) {
                        var eventData = {
                            target: elem,
                            event: e
                        };

                        scope.$emit(scope.event, eventData);
                        // scope.$apply();
                    }
                });

                scope.$on('$destroy', function() {
                   elem.off();
                });
            }
        };
    }
})();